module.exports = __webpack_public_path__ + "static/media/precios.b36598d6.svg";